import React from 'react';
// Icons
import { TbCategoryFilled } from 'react-icons/tb';
import { RiMoneyDollarCircleFill } from 'react-icons/ri';
import { FaBitcoin, FaChalkboardTeacher, FaCoins } from 'react-icons/fa';
import { AiFillGolden } from 'react-icons/ai';
import { PiChartLineFill } from 'react-icons/pi';
import { FaRankingStar } from 'react-icons/fa6';
import { IoCall } from 'react-icons/io5';

export const getIconByString = (
    iconName: string | null | undefined,
    className: string = 'size-5',
) => {
    switch (iconName) {
        case 'best-icon':
            return <TbCategoryFilled className={className} />;
        case 'broker-icon':
            return <RiMoneyDollarCircleFill className={className} />;
        case 'exchange-icon':
            return <FaBitcoin className={className} />;
        case 'prop-icon':
            return <FaCoins className={className} />;
        case 'gold-icon':
            return <AiFillGolden className={className} />;
        case 'teach-icon':
            return <FaChalkboardTeacher className={className} />;
        case 'tool-icon':
            return <PiChartLineFill className={className} />;
        case 'rank-icon':
            return <FaRankingStar className={className} />;
        case 'call-icon':
            return <IoCall className={className} />;
        default:
            return null;
    }
};
